import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import MenuItem from '@material-ui/core/MenuItem';
import { connect } from 'react-redux';
import { renderTextField, requiredValidator } from 'utils/formHelper';
import {
  fetchInvestor,
  createInvestment
} from 'actions/investors';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { dollars } from 'utils/money';
import { date } from 'utils/date';

import InvestmentForm from 'components/Investors/InvestmentForm';

const styles = {};

class Investments extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false }
  };

  componentWillMount = () => {
    const { dispatch, investorId } = this.props;
    investorId && dispatch(fetchInvestor(investorId));
  };

  handleClose = () => {
    this.setState({ open: false });
  }

  title = () => {
    const { mode } = this.props;
    if (mode === 'create') {
      return 'Create Investment';
    } else {
      return 'Update Investment';
    }
  }

  renderInvestments = (investments, investorId) => {
    return (
      <Table data-test='investmentsTable'>
        <TableHead>
          <TableRow>
            <TableCell>Product</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell>Interest rate</TableCell>
            <TableCell>Started at</TableCell>
            <TableCell>End at</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { investments.map(investment => this.renderInvestment(investment, investorId)) }
        </TableBody>
      </Table>
    )
  }

  renderInvestment = (investment, investorId) => {
    return (
      <TableRow key={investment.id}>
        <TableCell>
          { investment.product }
        </TableCell>
        <TableCell>
          { dollars(investment.amount) }
        </TableCell>
        <TableCell>
          { investment.interestRate }%
        </TableCell>
        <TableCell>
          { date(investment.startAt) }
        </TableCell>
        <TableCell>
          { date(investment.endAt) }
        </TableCell>
        <TableCell>
          <InvestmentForm
            buttonLabel='Edit'
            mode='update'
            investorId={investorId}
            investment={investment}
            form={`updateInvestment${investment.id}`}
          />
        </TableCell>
      </TableRow>
    )
  }

  render = () => {
    const { open } = this.state;
    const { investor, label } = this.props;

    return (
      <div>
        <a href="#"
          onClick={() => this.setState({ open: true })}
        >
          {label}
        </a>

        <Dialog
          open={open}
          onClose={this.handleClose}
          maxWidth='md'
        >
          <DialogTitle>{ "Investment details" }</DialogTitle>
          <DialogContent>
            <InvestmentForm
              buttonLabel='New investment'
              mode='create'
              investorId={investor.id}
              form={`newInvestment`}
            />
            { this.renderInvestments(investor.investments, investor.id) }
          </DialogContent>
        </Dialog>
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  const investor = state.investors.investors && state.investors.investors[ownProps.investorId];
  return { investor };
};

const connected = connect(mapStateToProps)(Investments);
export default withStyles(styles)(connected);



// WEBPACK FOOTER //
// ./src/components/Investors/Investments.js